<template>
  <div>
    <!-- {{ localData }} -->
    <el-form>
      <el-form-item :label="item.name" v-for="(item, index) in localData.config" :key="index" :required="item.required" label-width="140px">
        <el-input v-model="localData.data[item.key]" v-if="!item.type || item.type == '文字'" class="w240"></el-input>

        <el-input v-model="localData.data[item.key]" v-if="item.type == '密码'" type="password" class="w240"></el-input>

        <el-radio-group v-model="localData.data[item.key]" size="small" v-if="item.type == '按钮单选'">
          <el-radio-button :label="btn" v-for="(btn, bindex) in item.options" :key="bindex"></el-radio-button>
        </el-radio-group>

        <el-switch v-if="item.type == '开关'" v-model="localData.data[item.key]"> </el-switch>

        <el-select v-model="localData.data[item.key]" v-if="item.type == '下拉选择'" placeholder="请选择" class="w240">
          <el-option v-for="(select, sindex) in item.options" :key="sindex" :label="select" :value="select"> </el-option>
        </el-select>
        <el-select v-model="localData.data[item.key]" v-if="item.type == '下拉选择-可新增'" allow-create filterable placeholder="请选择" class="w240">
          <el-option v-for="(select, sindex) in item.options" :key="sindex" :label="select" :value="select"> </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    value: {
      type: null,
      default: null
    }
  },

  data() {
    return {
      localData: this.value ? _.cloneDeep(this.value) : {}
    }
  },

  created() {
    this.value.config.forEach(item => {
      if (item.default && !this.localData.data[item.key]) {
        this.localData.data[item.key] = item.default
      }
    })
  },
  watch: {
    localData: {
      handler(newVal) {
        if (!this.isEqual(newVal, this.value)) {
          this.$emit('input', _.cloneDeep(newVal)) // 值变化时通知父级
        }
      },
      deep: true
    },
    value: {
      handler(newVal) {
        // this.localData = _.cloneDeep(newVal)
        this.localData = newVal || {}
      }
    }
  },
  methods: {
    isEqual(a, b) {
      // 智能值比对（处理所有数据类型）
      if (typeof a !== typeof b) return false
      if (typeof a === 'object' && a !== null && b !== null) {
        // 处理引用类型
        return _.isEqual(a, b) // 使用 lodash 深度比对
      }
      return a === b // 基本类型直接比对
    }
  }
}
</script>

<style lang="scss" scoped></style>
